import { Grid, Typography } from '@mui/material';
import { isNotEmpty } from 'ramda';
import { useTranslation } from 'react-i18next';

import { SearchClearRefinements } from '../SearchClearRefinements/SearchClearRefinements';
import { SearchFilters } from '../SearchFilters/SearchFilters.tsx';
import { SearchResultHits } from '../SearchResultHits/SearchResultHits';
import { SearchSortBy } from '../SearchSortBy/SearchSortBy';
import { useSearchDomainConfig } from '~/routes/Search/components/SearchDomainConfigProvider';
import { SearchDomain } from '~/routes/Search/types/SearchDomain.ts';

import { SearchFilterHeader } from './SearchResults.styled';

export interface SearchResultsProps {
  domain: SearchDomain;
}

export const SearchResults = ({ domain }: SearchResultsProps) => {
  const { searchConfigByDomain } = useSearchDomainConfig();
  const { t } = useTranslation(undefined, { keyPrefix: 'SearchDialog' });
  const { sortByItems, filters } = searchConfigByDomain(domain);

  return (
    <Grid container spacing={6} sx={{ flexGrow: 1 }}>
      <Grid size={8}>
        <SearchResultHits domain={domain} />
      </Grid>
      <Grid size={4}>
        {sortByItems.length > 0 ? <SearchSortBy items={sortByItems} /> : null}
        {isNotEmpty(filters) && (
          <>
            <SearchFilterHeader>
              <Typography variant="subtitle1">{t('filter.title')}</Typography>
              <SearchClearRefinements />
            </SearchFilterHeader>
            <SearchFilters domain={domain} />
          </>
        )}
      </Grid>
    </Grid>
  );
};
